import React from "react";
import Link from "../TrailingSlashLink";

import mainLogo from "../../assets/image/logo3.png";

const Logo = ({ white, height, className = "", to = "/", ...rest }) => {
  const logoStyle = {
    maxHeight: height || "180px",
    width: "200px",
    objectFit: "contain",
    marginBottom: "4px",
  };

  return (
    <Link to={to} className={`d-block ${className}`} {...rest}>
      <img
        src={mainLogo}
        alt="Logo"
        className="logo-img"
        style={logoStyle}
      />
    </Link>
  );
};

export default Logo;
